<div class="expansion-panel">
  <h2 l10nTranslate>All GRC Modules in One Platform</h2>
  <div class="expansion-panel__container">
    <mat-accordion>
      <mat-expansion-panel id="panel-1" (afterExpand)="scrollToTop('panel-1')" [expanded]="true" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
          <mat-panel-title l10nTranslate>Compliance Mangment</mat-panel-title>
        </mat-expansion-panel-header>
        <h5 class="expansion-panel__h5" l10nTranslate>Instant access to major frameworks</h5>
        <div class="expansion-panel__descriptions-holder">
          <div class="expansion-panel__description">
            <img src="../../../../assets/svg/arrowright2.svg" alt="">
            <span l10nTranslate>Never miss regulators’ updates</span>
          </div>
          <div class="expansion-panel__description">
            <img src="../../../../assets/svg/arrowright2.svg" alt="">
            <span l10nTranslate>Export reports in regulator approved format</span>
          </div>
          <div class="expansion-panel__description">
            <img src="../../../../assets/svg/arrowright2.svg" alt="">
            <span l10nTranslate>Automate controls overlapping</span>
          </div>
          <div class="expansion-panel__description">
            <img src="../../../../assets/svg/arrowright2.svg" alt="">
            <span l10nTranslate>Access a growing library of frameworks</span>
          </div>
        </div>
        <section class="section-image">
          <img *ngIf="currentLanguage == 'en'" src="../../../../assets/images/Compliance Mangment en.png"
            alt="Compliance-Mangment">
          <img *ngIf="currentLanguage == 'ar'" src="../../../../assets/images/Compliance Mangment ar.png"
            alt="Compliance-Mangment">
        </section>
      </mat-expansion-panel>

      <mat-expansion-panel id="panel-2" (afterExpand)="scrollToTop('panel-2')" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
          <mat-panel-title l10nTranslate>Risk Management</mat-panel-title>
        </mat-expansion-panel-header>
        <h5 class="expansion-panel__h5" l10nTranslate>Manage your risks proactively</h5>
        <div class="expansion-panel__descriptions-holder">
          <div class="expansion-panel__description">
            <img src="../../../../assets/svg/arrowright2.svg" alt="">
            <span l10nTranslate>Streamline risk identification, assessment, treatment, and review process</span>
          </div>
          <div class="expansion-panel__description">
            <img src="../../../../assets/svg/arrowright2.svg" alt="">
            <span l10nTranslate>Visualize risk analysis through rich analytics and reporting</span>
          </div>
          <div class="expansion-panel__description">
            <img src="../../../../assets/svg/arrowright2.svg" alt="">
            <span l10nTranslate>Track how controls and compliance obligations reduce your risk</span>
          </div>
          <div class="expansion-panel__description">
            <img src="../../../../assets/svg/arrowright2.svg" alt="">
            <span l10nTranslate>Manage escalations and reporting</span>
          </div>
        </div>
        <section class="section-image">
          <img *ngIf="currentLanguage == 'en'" src="../../../../assets/images/Risk Management en.png" />
          <img *ngIf="currentLanguage == 'ar'" src="../../../../assets/images/Risk Management ar.png" />
        </section>
      </mat-expansion-panel>

      <mat-expansion-panel id="panel-3" (afterExpand)="scrollToTop('panel-3')" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
          <mat-panel-title l10nTranslate>Policy Management</mat-panel-title>
        </mat-expansion-panel-header>
        <h5 class="expansion-panel__h5" l10nTranslate>Adopt new approach to policy management</h5>
        <div class="expansion-panel__descriptions-holder">
          <div class="expansion-panel__description">
            <img src="../../../../assets/svg/arrowright2.svg" alt="">
            <span l10nTranslate>Streamlined review and approval process</span>
          </div>
          <div class="expansion-panel__description">
            <img src="../../../../assets/svg/arrowright2.svg" alt="">
            <span l10nTranslate>Centralized management of all organizational policies</span>
          </div>
          <div class="expansion-panel__description">
            <img src="../../../../assets/svg/arrowright2.svg" alt="">
            <span l10nTranslate>Turn policies from static documents into manageable and trackable ones</span>
          </div>
        </div>
        <section class="section-image">
          <img *ngIf="currentLanguage == 'en'" src="../../../../assets/images/Policy Management en.png" />
          <img *ngIf="currentLanguage == 'ar'" src="../../../../assets/images/Policy Management ar.png" />
        </section>
      </mat-expansion-panel>

      <mat-expansion-panel id="panel-4" (afterExpand)="scrollToTop('panel-4')" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
          <mat-panel-title l10nTranslate>Audit Management</mat-panel-title>
        </mat-expansion-panel-header>
        <h5 class="expansion-panel__h5" l10nTranslate>Bridge the gap between compliance and audit teams</h5>
        <div class="expansion-panel__descriptions-holder">
          <div class="expansion-panel__description">
            <img src="../../../../assets/svg/arrowright2.svg" alt="">
            <span l10nTranslate>Perform fast compliance audit</span>
          </div>
          <div class="expansion-panel__description">
            <img src="../../../../assets/svg/arrowright2.svg" alt="">
            <span l10nTranslate>Assign internal and external auditors and track progress</span>
          </div>
          <div class="expansion-panel__description">
            <img src="../../../../assets/svg/arrowright2.svg" alt="">
            <span l10nTranslate>Plan audit annual calendar with regulators</span>
          </div>
        </div>
        <section class="section-image">
          <img *ngIf="currentLanguage == 'en'" src="../../../../assets/images/Audit Management en.png" />
          <img *ngIf="currentLanguage == 'ar'" src="../../../../assets/images/Audit Management ar.png" />
        </section>
      </mat-expansion-panel>
      <mat-expansion-panel id="panel-5" (afterExpand)="scrollToTop('panel-5')" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
          <mat-panel-title l10nTranslate>Initiatives Management</mat-panel-title>
        </mat-expansion-panel-header>
        <h5 class="expansion-panel__h5" l10nTranslate>Integrated approach to manage initiatives within the GRC context</h5>
        <div class="expansion-panel__descriptions-holder">
          <div class="expansion-panel__description">
            <img src="../../../../assets/svg/arrowright2.svg" alt="">
            <span l10nTranslate>Create initiatives, assign owners, and track progress</span>
          </div>
          <div class="expansion-panel__description">
            <img src="../../../../assets/svg/arrowright2.svg" alt="">
            <span l10nTranslate>Route initiatives for approvals and assign implementation budget</span>
          </div>
          <div class="expansion-panel__description">
            <img src="../../../../assets/svg/arrowright2.svg" alt="">
            <span l10nTranslate>Map controls and risks with initiatives</span>
          </div>
          <div class="expansion-panel__description">
            <img src="../../../../assets/svg/arrowright2.svg" alt="">
            <span l10nTranslate>Generate detailed reports and share them with stakeholders</span>
          </div>
        </div>
        <section class="section-image">
          <img *ngIf="currentLanguage == 'en'" src="../../../../assets/images/initiatives Management en.png"/>
          <img *ngIf="currentLanguage == 'ar'" src="../../../../assets/images/initiatives Management ar.png" />
        </section>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>